import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _conversation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _getConversationRequest = {};
var _getConversationResponse = { conversation: '_conversation' };
function resolveWixInnovationAssistantWidgetV1ConversationsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
            {
                srcPath: '/innovation/widget',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-assistant-widget',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves the conversation for the site visitor calling this method.
 *
 * This method must be called using the site visitor or site member identity ([SDK](https://dev.wix.com/docs/sdk/articles/get-started/about-identities#site-member) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/about-identities#site-member)) to identify the site visitor that is requesting the conversation.
 */
export function getConversation(payload) {
    var _a = serializer(_getConversationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getConversationResponse, {
        _conversation: _conversation,
    }).fromJSON;
    function __getConversation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.widget.v1.conversation',
            method: 'GET',
            methodFqn: 'wix.innovation.assistant.widget.v1.Conversations.GetConversation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixInnovationAssistantWidgetV1ConversationsUrl({
                protoPath: '/v1/conversation',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getConversation.fromReq = fromReq;
    __getConversation.__isAmbassador = true;
    return __getConversation;
}
//# sourceMappingURL=http.impl.js.map